import { render, staticRenderFns } from "./jurisdictionList.vue?vue&type=template&id=62d67545&scoped=true"
import script from "./jurisdictionList.vue?vue&type=script&lang=js"
export * from "./jurisdictionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d67545",
  null
  
)

export default component.exports